import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WIconButton = /*#__PURE__*/function (_Vue) {
  function WIconButton() {
    var _this;
    _classCallCheck(this, WIconButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WIconButton, [].concat(args));
    _defineProperty(_this, "btnClass", void 0);
    _defineProperty(_this, "iconClass", void 0);
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "loading", void 0);
    _defineProperty(_this, "disabled", void 0);
    return _this;
  }
  _inherits(WIconButton, _Vue);
  return _createClass(WIconButton);
}(Vue);
export { WIconButton as default };
__decorate([Prop({
  default: ''
})], WIconButton.prototype, "btnClass", void 0);
__decorate([Prop({
  default: ''
})], WIconButton.prototype, "iconClass", void 0);
__decorate([Prop({
  default: ''
})], WIconButton.prototype, "icon", void 0);
__decorate([Prop({
  default: false
})], WIconButton.prototype, "loading", void 0);
__decorate([Prop({
  default: false
})], WIconButton.prototype, "disabled", void 0);